<template>
  <section id="ueber-mich">
    <h2 class="text-uppercase text-center">
      Über mich
    </h2>
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="row justify-content-end">
          <div class="col-md-10 col-xs-12">
            <img
              src="../assets/portrait.jpg"
              class="img-fluid img-portrait"
              alt="Portrait C. Bruns"
            >
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <ul class="">
          <li>4-jähriges Vollzeitstudium Osteopathie (BSc) , Osteopathie Schule Deutschland / Dresden International University (DIU)</li>
          <li>staatlich geprüfte Heilpraktikerin</li>
          <li>2-jährige Fortbildung in Kinderosteopathie</li>
          <li>Tutorin in der Lehrpraxis der Osteopathie Schule Deutschland</li>
          <li>Mitgliedschaft im Verband VOSD</li>
          <li>Leben und Arbeit in Berlin</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
    name: "ContentUeberMich",
      mounted: function() {
        if(this.$route.path && this.$route.path == '/ueber-mich') {
          const element = document.getElementById(this.$route.path.substring(1));
          if(element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }
}
</script>

<style scoped>
  li {
    margin-bottom: 2rem;
  }
  ul {
    list-style-type: "+ "; 
  }

  @media (max-width: 767.98px) {
    .img-portrait {
      margin-bottom: 1rem;
    }
  }
</style>